import React, { useState } from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';
import PermissionCheck from '@/components/common/PermissionCheck';
import { Link } from 'react-router-dom';
const DataTable = ({ isLoading, tableColumn, dataSource, totalRecord, dataFilter, onChangePage, handleDrawerOpen, deleteRecord }) => {
    // Default customer id which should not be deleted
    const constDefaultUserId = '64b17c2f1e34a5d9bdf103a4';
    return (
        <TableWrapServerSide
            tableColumnList={tableColumn}
            totalDataCount={totalRecord}
            initialPage={dataFilter?.page}
            onChangePage={onChangePage}
            per_page={dataFilter?.limit}
        >
            {dataSource.length > 0 ? (
                dataSource.map((data) => (
                    <tr className="db-table-body-tr" key={data._id}>
                        <td className="db-table-body-td">{data.name}</td>
                        <td className="db-table-body-td">{data.email}</td>
                        <td className="db-table-body-td">{data.phone_no}</td>
                        <td className="db-table-body-td">
                            {Number(data.status) === 1 ? (
                                <span className="active">Active</span>
                            ) : (
                                <span className="inactive">Inactive</span>
                            )}
                        </td>
                        {/* New Credit Column */}
                        <td className="db-table-body-td">
                            {data.creditEnabled ? (
                                <span>
                                    Limit: {data.creditLimit} | Owes: {data.outstandingCredit} | Available:{' '}
                                    {data.creditLimit - data.outstandingCredit}
                                </span>
                            ) : (
                                <span>Disabled</span>
                            )}
                        </td>
                        <td className="db-table-body-td hidden-print hidden-print-remove">
                            <div className="flex justify-start items-center sm:items-start sm:justify-start gap-1.5">
                            <PermissionCheck permsission={'view_customers'}>
                                    <Link
                                      to={`/admin/customers/show/${data._id}`}
                                      className="db-table-action view"
                                    >
                                        <i className="lab lab-view"></i>
                                        <span className="db-tooltip">view</span>
                                    </Link>
                               </PermissionCheck>
                                <PermissionCheck permsission={'update_customers'}>
                                    <button
                                        data-modal="#sidebar"
                                        className="db-table-action edit"
                                        onClick={() => handleDrawerOpen(data._id)}
                                    >
                                        <i className="lab lab-edit-line"></i>
                                        <span className="db-tooltip">edit</span>
                                    </button>
                                </PermissionCheck>
                                <PermissionCheck permsission={'delete_customers'}>
                                    {data._id !== constDefaultUserId && (
                                        <button className="db-table-action delete" onClick={() => deleteRecord(data._id)}>
                                            <i className="lab lab-delete"></i>
                                            <span className="db-tooltip">delete</span>
                                        </button>
                                    )}
                                </PermissionCheck>
                            </div>
                        </td>
                    </tr>
                ))
            ) : (
                <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
            )}
        </TableWrapServerSide>
    );
};

export default DataTable;
